var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.extensionData.length)?_c('div',_vm._l((_vm.extensionData),function(item,i){return _c('div',{key:`extensionData${_vm.location}${i}`},[_c(item.component,{tag:"component",attrs:{"resource":_vm.resource}})],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }